export default __webpack_public_path__ + "static/media/instagram-white.9ee065e1.svg";